<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>
      {{'Estrutura de ' | translate}} {{tipo == 1 ? ('grupo' | nomenclatura | async) : ('ministerio' | nomenclatura |
      async)}}
    </ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <ion-card>
    <ion-card-header>
      <i class="fas fa-users">
        <ion-label class="title">{{grupoNome}}</ion-label>
      </i>
    </ion-card-header>
    <div *ngFor="let h of hierarquiaList">
      <div *ngFor="let f of h.funcoes">
        <ion-list *ngIf="f.hierarquiaGrupoFuncao">
          <ion-item>
            <ion-avatar slot="start">
              <img [src]="f.hierarquiaGrupoFuncao.pessoa.foto | image:' '" />
            </ion-avatar>

            <ion-label *ngIf="f.hierarquiaGrupoFuncao">
              <h3 *ngIf="f.hierarquiaGrupoFuncao.pessoa">{{f.hierarquiaGrupoFuncao.pessoa.nome}}</h3>
              <p *ngIf="f.nome">{{f.nome}}</p>
            </ion-label>
          </ion-item>
          <div class="linha-horizontal"></div>
        </ion-list>
      </div>
    </div>
  </ion-card>
  <sem-registro *ngIf="!hasHierarquiaGrupoFuncao"></sem-registro>
</ion-content>
